import "dc/dc.min.css";
import "../../crossfilter/style.css";

import React from "react";
import dc from "dc";
import crossfilter from "crossfilter";
import data from "../../crossfilter/judgit-crossfilter.json";
import $ from "jquery";
import { formatCurrency } from "../../services";

export class CrossFilter extends React.Component {
  componentDidMount() {
    /*
    parameters
*/
    var barWidth = 230;
    var barHeight = 700;
    var accountLetters = 14;

    /*
    create Chart objects
*/
    var valueByTwoChart = dc.rowChart("#value-by-two");
    var valueByFourChart = dc.rowChart("#value-by-four");

    /*
      initialise
    */
    window.valueByTwoChart = valueByTwoChart;
    window.valueByFourChart = valueByFourChart;
    window.dc = dc;

    function dataLoaded() {
      /*
        data preparation
        */
      data.forEach(function (d, i) {
        const digits = parseInt(d.minBudget).toString(10).length - 1;
        d.projectId = parseInt(d.projectId);
        d.maxBudget = parseFloat(d.maxBudget);
        d.minBudget = parseFloat(d.minBudget);
        d.digits = `${formatCurrency(10 ** (digits + 1))}〜${formatCurrency(
          10 ** digits
        )}`;
        d.startYear = parseInt(d.startYear);
        d.endYear = parseInt(d.endYear);
      });

      /*
        Two - accountingCategory
        */
      function reduceAddTwo(p, v) {
        if (v.accountingCategory[0] === "") return p;
        v.accountingCategory.forEach(function (val, idx) {
          p[val] = (p[val] || 0) + 1;
        });
        return p;
      }

      function reduceRemoveTwo(p, v) {
        if (v.accountingCategory[0] === "") return p;
        v.accountingCategory.forEach(function (val, idx) {
          p[val] = (p[val] || 0) - 1;
        });
        return p;
      }

      function reduceInitialTwo() {
        return {};
      }

      /*
        Three - category
        */

      /*
        create Crossfilter instances
    */
      var ndx = crossfilter(data);

      /*
        value-by-two
    */
      var valueByTwo = ndx.dimension(function (d) {
        return d.accountingCategory;
      });

      var valueByTwoGroup = valueByTwo
        .groupAll()
        .reduce(reduceAddTwo, reduceRemoveTwo, reduceInitialTwo)
        .value();

      valueByTwoGroup.all = function () {
        var newObject = [];
        for (var key in this) {
          if (this.hasOwnProperty(key) && key !== "all") {
            newObject.push({
              key: key,
              value: this[key],
            });
          }
        }
        return newObject;
      };

      valueByTwoChart
        .width(barWidth)
        .height(barHeight)
        .margins({ top: 0, left: 10, right: 10, bottom: 20 })
        .group(valueByTwoGroup)
        .dimension(valueByTwo)
        .ordering(function (d) {
          return -d.value;
        })
        .ordinalColors(["#000"])
        .label(function (d) {
          var labelKey;
          if (d.key.toString().length > accountLetters) {
            labelKey = d.key.substr(0, accountLetters).toString() + "...";
          } else {
            labelKey = d.key.toString();
          }
          return labelKey + "(" + d.value + ")";
        })
        .title(function (d) {
          return d.key + "(" + d.value + ")";
        })
        .elasticX(false)
        .xAxis()
        .ticks(4);

      /*
        value-by-four
    */
      var valueByFour = ndx.dimension(function (d) {
        return d.digits;
      });

      var valueByFourGroup = valueByFour.group();

      valueByFourChart
        .width(barWidth)
        .height(barHeight)
        .margins({ top: 0, left: 10, right: 10, bottom: 20 })
        .group(valueByFourGroup)
        .dimension(valueByFour)
        .ordering(function (d) {
          return -d.value;
        })
        .ordinalColors(["#000"])
        .label(function (d) {
          return d.key + "(" + d.value + ")";
        })
        .title(function (d) {
          return d.key + "(" + d.value + ")";
        })
        .elasticX(false)
        .xAxis()
        .ticks(4);

      /*
        rendering all
    */
      dc.renderAll();

      resizeFunc();
    }

    dataLoaded();

    function resizeFunc() {
      var chart2 = $("#value-by-two svg");
      var chart4 = $("#value-by-four svg");

      var container2 = chart2.parent();

      $(window)
        .on("resize", function () {
          var targetWidth = container2.width();

          chart2.attr("width", targetWidth);
          chart2.attr("height", "700");

          chart4.attr("width", targetWidth);
          chart4.attr("height", "700");
        })
        .trigger("resize");
    }
  }

  render() {
    return (
      <>
        <div className="columns">
          <div className="column is-half">
            <div id="value-by-two" className="m-all t-all d-all block">
              <div className="is-half h2height">
                <h2 className="subtitle h2titlebottom">会計区分</h2>
                <a
                  className="reset"
                  href="javascript:valueByTwoChart.filterAll();dc.redrawAll();"
                  style={{ display: "none" }}
                >
                  リセット
                </a>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>

          <div className="column is-half">
            <div id="value-by-four" className="m-all t-all d-all block">
              <div className="is-half h2height">
                <h2 className="subtitle h2titlebottom">予算最小額 桁数</h2>
                <a
                  className="reset"
                  href="javascript:valueByFourChart.filterAll();dc.redrawAll();"
                  style={{ display: "none" }}
                >
                  リセット
                </a>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
        <button
          className="button is-info is-fullwidth"
          onClick={() => {
            this.props.history.push(`/projects#chart`);
          }}
        >
          📋 行政事業検索
        </button>
      </>
    );
  }
}
